import React from "react";
import { StoryblokRichtext } from "storyblok-rich-text-react-renderer";
import Blok from "../../../interfaces/Storyblok/Blok.interface";
import RichText from "../../atoms/RichText/RichText.atom";
import { ButtonProps } from "../../../interfaces/Button.interface";
import { ButtonTypes } from "../../../interfaces/enums/ButtonTypes.enum";
import { ButtonSizeTypes } from "../../../interfaces/enums/ButtonSizeTypes.enum";
import Button from "../../atoms/Button/Button.component";
import BlokWithBorderIcons from "../../../interfaces/Storyblok/BlokWithBorderIcons.interface";
import BorderIconsFactory from "../../utils/BorderIconsFactory/BorderIconsFactory.util";
import { BorderIconType } from "../../utils/BorderIconsFactory/BorderIcon.util";

interface ArticleRichTextProps extends BlokWithBorderIcons {
  content: StoryblokRichtext;
  align_content?: "left" | "center" | "right";
  cta: ButtonProps[];
}

const ArticleRichText: React.FC<ArticleRichTextProps> = ({
  content,
  align_content,
  cta,
  border_icon_top_left,
  border_icon_top_right,
  border_icon_bottom_left,
  border_icon_bottom_right,
}) => {
  return (
    <div>
      <BorderIconsFactory
        type={BorderIconType.Blok}
        border_icon_top_left={border_icon_top_left}
        border_icon_top_right={border_icon_top_right}
        border_icon_bottom_left={border_icon_bottom_left}
        border_icon_bottom_right={border_icon_bottom_right}
      >
        <div className="container mx-auto py-4 my-6 lg:my-6 lg:px-6">
          <div className="space-y-8">
            <RichText
              hasHeadingAbove={false}
              content={content}
              isArticleRichTextConfigRequired={true}
              alignment={align_content}
            />
            {cta && !!cta.length && cta[0].label && cta[0].link && (
              <Button
                link={cta[0].link}
                label={cta[0].label}
                type={ButtonTypes.PRIMARY}
                size={ButtonSizeTypes.DEFAULT}
                className={"w-full sm:w-auto"}
              />
            )}
          </div>
        </div>
      </BorderIconsFactory>
    </div>
  );
};

export default ArticleRichText;
